export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E6DFD3] bg-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 flex-wrap">
        <p className="font-serif text-lg text-[#2D231E]">WorkSpaces</p>
        <p className="font-sans text-xs tracking-[0.2em] uppercase text-[#8B7355]">
          Saba · Toowoomba &nbsp;·&nbsp; Buderim · Sunshine Coast
        </p>
        <p className="font-sans text-xs text-[#8B7355]">
          © {new Date().getFullYear()} WorkSpaces
        </p>
      </div>
    </footer>
  );
};
